import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromUserSettings from '../reducers/user-settings.reducer';

export const selectUserSettingsState = createFeatureSelector<fromUserSettings.UserSettingsState>(
  fromUserSettings.userSettingsFeatureKey
);

export const selectUserPreferences = createSelector(selectUserSettingsState, state => state.userPreferences);